import {AnchorProvider, Wallet} from "@project-serum/anchor";
import {connection} from "../../constants/factory";

export const createProvider = (wallet: Wallet): AnchorProvider => {
  return new AnchorProvider(connection, wallet, {
    commitment: 'processed',
    preflightCommitment: 'processed',
  });
}
